module.exports = __webpack_public_path__ + "src/img/up.2bc7bce9.svg";